import { Quote } from 'lucide-react';

import type { Testimonial } from './useTestimonials';

type TestimonialCardProps = {
  testimonial: Testimonial;
};

const TestimonialCard = ({ testimonial }: TestimonialCardProps) => {
  return (
    <div className="flex flex-col gap-6 rounded-lg bg-surface-primary p-10 shadow-card">
      <Quote className="h-8 w-8 text-accent-primary" />
      <p className="font-body text-base italic leading-relaxed text-foreground-secondary">
        &ldquo;{testimonial.quote}&rdquo;
      </p>
      <div className="flex items-center gap-4">
        <div className="h-12 w-12 overflow-hidden rounded-full">
          <img
            src={testimonial.avatar}
            alt={testimonial.author}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover"
          />
        </div>
        <div className="flex flex-col gap-1">
          <span className="font-body text-base font-semibold text-foreground-primary">
            {testimonial.author}
          </span>
          <span className="font-body text-sm text-foreground-tertiary">
            {testimonial.role}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
